import { Chip } from '@mui/material';

import {
  BONUS_STATUS_LABELS,
  CARD_POOL_STATUS_LABELS,
  CARD_STATUS_LABELS,
  CARD_TYPE_LABELS,
  PROGRAM_MODEL_LABELS,
  RESERVATION_STATUS_LABELS,
  RULE_TYPE_LABELS,
  TX_TYPE_LABELS,
} from '../../model/labels';
import type {
  BonusAccountStatus,
  BonusTransactionType,
  CardPoolStatus,
  LoyaltyCardStatus,
  LoyaltyCardType,
  LoyaltyProgramModel,
  LoyaltyRuleType,
  ReservationStatus,
} from '../../model/types';

/** Status chips pair colour with a label (never colour alone) per the design system. */

export function BonusStatusChip({ status }: { status: BonusAccountStatus }) {
  const color = status === 'ACTIVE' ? 'success' : status === 'BLOCKED' ? 'warning' : 'default';
  return <Chip size="small" variant="outlined" color={color} label={BONUS_STATUS_LABELS[status]} />;
}

export function CardStatusChip({ status }: { status: LoyaltyCardStatus }) {
  const color = status === 'ACTIVE' ? 'success' : status === 'BLOCKED' ? 'warning' : 'default';
  return <Chip size="small" variant="outlined" color={color} label={CARD_STATUS_LABELS[status]} />;
}

export function CardTypeChip({ type }: { type: LoyaltyCardType }) {
  return <Chip size="small" variant="outlined" label={CARD_TYPE_LABELS[type]} />;
}

export function TxTypeChip({ type }: { type: BonusTransactionType }) {
  const color = type === 'ACCRUAL' ? 'success' : type === 'REDEMPTION' ? 'warning' : 'default';
  return <Chip size="small" variant="outlined" color={color} label={TX_TYPE_LABELS[type]} />;
}

export function RuleTypeChip({ type }: { type: LoyaltyRuleType }) {
  return <Chip size="small" variant="outlined" label={RULE_TYPE_LABELS[type]} />;
}

export function EnabledChip({ enabled }: { enabled: boolean }) {
  return (
    <Chip
      size="small"
      variant="outlined"
      color={enabled ? 'success' : 'default'}
      label={enabled ? 'Включено' : 'Выключено'}
    />
  );
}

export function CardPoolStatusChip({ status }: { status: CardPoolStatus }) {
  return (
    <Chip
      size="small"
      variant="outlined"
      color={status === 'AVAILABLE' ? 'success' : 'default'}
      label={CARD_POOL_STATUS_LABELS[status]}
    />
  );
}

export function ProgramModelChip({ model }: { model: LoyaltyProgramModel }) {
  const color = model === 'NONE' ? 'default' : model === 'DISCOUNT' ? 'secondary' : 'primary';
  return <Chip size="small" color={color} label={PROGRAM_MODEL_LABELS[model]} />;
}

export function ReservationStatusChip({ status }: { status: ReservationStatus }) {
  const color = status === 'RESERVED' ? 'warning' : status === 'CONFIRMED' ? 'success' : 'default';
  return (
    <Chip size="small" variant="outlined" color={color} label={RESERVATION_STATUS_LABELS[status]} />
  );
}
